import React, { useEffect, useState } from 'react';
import { db, auth } from './firebaseConfig';
import { collection, getDocs, addDoc, deleteDoc, updateDoc, doc, getDoc, setDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './icons';

const Questionarios = () => {
  const [questionarios, setQuestionarios] = useState([]);

  useEffect(() => {
    const fetchQuestionarios = async () => {
      await auth.authStateReady();
      const querySnapshot = await getDocs(collection(db, 'questionarios'));
      const questionariosList = [];

      for (const document of querySnapshot.docs) {
        const data = document.data();
        if (data.gravarAudio !== true && auth.currentUser && !auth.currentUser.isAnonymous) {
          try {
            await updateDoc(doc(db, 'questionarios', document.id), { gravarAudio: true });
          } catch (err) {
            console.warn('Não foi possível atualizar gravarAudio:', err);
          }
        }
        questionariosList.push({
          id: document.id,
          ...data,
          gravarAudio: true,
        });
      }

      setQuestionarios(questionariosList);
    };

    fetchQuestionarios().catch((err) => {
      console.error('Erro ao listar questionarios:', err);
    });
  }, []);

  const adicionarQuestionario = async () => {
    try {
      const novoQuestionario = {
        nome: 'Novo Questionário',
        ativo: true,
        suspenso: false,
        gravarAudio: true,
        questions: [
          {
            id: 1,
            tituloBloco: '',
            question: 'Digite sua pergunta aqui',
            type: 'text',
            options: [],
            required: false,
          },
        ],
      };
      const docRef = await addDoc(collection(db, 'questionarios'), novoQuestionario);
      setQuestionarios([...questionarios, { id: docRef.id, ...novoQuestionario }]);
      alert('Questionário criado com sucesso! Agora você pode editá-lo.');
    } catch (error) {
      console.error('Erro ao adicionar questionário:', error);
      alert('Erro ao criar questionário. Tente novamente.');
    }
  };

  const excluirQuestionario = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este questionário? Esta ação não pode ser desfeita.')) {
      try {
        await deleteDoc(doc(db, 'questionarios', id));
        setQuestionarios(questionarios.filter((q) => q.id !== id));
        alert('Questionário excluído com sucesso!');
      } catch (error) {
        console.error('Erro ao excluir questionário:', error);
        alert('Erro ao excluir questionário. Tente novamente.');
      }
    }
  };

  const toggleSuspenso = async (id, suspenso) => {
    const mensagem = suspenso
      ? 'Deseja retomar este questionário? O link de resposta voltará a funcionar.'
      : 'Deseja suspender este questionário? Ninguém poderá acessar o link de resposta.';

    if (window.confirm(mensagem)) {
      try {
        await updateDoc(doc(db, 'questionarios', id), { suspenso: !suspenso });
        setQuestionarios(questionarios.map((q) => (q.id === id ? { ...q, suspenso: !suspenso } : q)));
        alert(`Questionário ${suspenso ? 'retomado' : 'suspenso'} com sucesso!`);
      } catch (error) {
        console.error('Erro ao atualizar questionário:', error);
        alert('Erro ao atualizar questionário. Tente novamente.');
      }
    }
  };

  const toggleAtivo = async (id, ativo) => {
    const mensagem = ativo
      ? 'Deseja desativar este questionário? Ele não ficará mais disponível para resposta.'
      : 'Deseja ativar este questionário?';

    if (window.confirm(mensagem)) {
      try {
        await updateDoc(doc(db, 'questionarios', id), { ativo: !ativo });
        setQuestionarios(questionarios.map((q) => (q.id === id ? { ...q, ativo: !ativo } : q)));
        alert(`Questionário ${ativo ? 'desativado' : 'ativado'} com sucesso!`);
      } catch (error) {
        console.error('Erro ao atualizar questionário:', error);
        alert('Erro ao atualizar questionário. Tente novamente.');
      }
    }
  };

  const clonarQuestionario = async (docIdOriginal) => {
    if (window.confirm('Deseja criar uma cópia deste questionário?')) {
      try {
        const docRef = doc(db, 'questionarios', docIdOriginal);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          alert('Documento não encontrado!');
          return;
        }

        const dados = { ...docSnap.data(), gravarAudio: true, suspenso: false };
        const novaRef = doc(collection(db, 'questionarios'));
        await setDoc(novaRef, dados);

        const novo = { id: novaRef.id, ...dados };
        setQuestionarios([...questionarios, novo]);
        alert('Questionário clonado com sucesso!');
      } catch (error) {
        console.error('Erro ao clonar documento:', error);
        alert('Erro ao clonar questionário. Tente novamente.');
      }
    }
  };

  return (
    <>
      <div className="page-header-row">
        <span className="page-header-count">
          {questionarios.length} questionário{questionarios.length !== 1 ? 's' : ''}
        </span>
        <button type="button" className="btn-add-primary" onClick={adicionarQuestionario}>
          <FontAwesomeIcon icon="plus" />
          Novo questionário
        </button>
      </div>

      <div className="page-content-card">
        {questionarios.length === 0 ? (
          <div className="table-empty">
            <FontAwesomeIcon icon="clipboard-list" size="2x" style={{ opacity: 0.3 }} />
            <p>Nenhum questionário criado ainda.</p>
            <button type="button" className="btn-add-primary" onClick={adicionarQuestionario} style={{ marginTop: 16 }}>
              <FontAwesomeIcon icon="plus" />
              Criar primeiro questionário
            </button>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Status</th>
                <th>Áudio</th>
                <th>Perguntas</th>
                <th style={{ textAlign: 'right' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {questionarios.map((q) => (
                <tr key={q.id}>
                  <td className="col-name">{q.nome}</td>
                  <td>
                    <span
                      className={`status-badge ${
                        q.suspenso ? 'suspended' : q.ativo ? 'active' : 'inactive'
                      }`}
                    >
                      {q.suspenso ? 'Suspenso' : q.ativo ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td>
                    <span className="status-badge active" title="Grava áudio da entrevista automaticamente">
                      🎙️ Sim
                    </span>
                  </td>
                  <td>{q.questions?.length ?? 0}</td>
                  <td>
                    <div className="table-actions">
                      <Link to={`/editar-questionario/${q.id}`} className="btn-primary-sm">
                        Editar
                      </Link>
                      <Link
                        to={`/responder-questionario/${q.id}?preview=true`}
                        className="btn-ghost-sm"
                      >
                        Visualizar
                      </Link>
                      {q.ativo && !q.suspenso ? (
                        <Link
                          to={`/responder-questionario/${q.id}`}
                          className="btn-success-sm"
                        >
                          Responder
                        </Link>
                      ) : (
                        <button
                          type="button"
                          className="btn-success-sm"
                          disabled
                          title={
                            q.suspenso
                              ? 'Questionário suspenso'
                              : 'Ative o questionário primeiro'
                          }
                        >
                          Responder
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn-ghost-sm"
                        onClick={() => toggleSuspenso(q.id, !!q.suspenso)}
                      >
                        {q.suspenso ? 'Retomar' : 'Suspender'}
                      </button>
                      <button
                        type="button"
                        className="btn-ghost-sm"
                        onClick={() => toggleAtivo(q.id, q.ativo)}
                      >
                        {q.ativo ? 'Desativar' : 'Ativar'}
                      </button>
                      <button
                        type="button"
                        className="btn-ghost-sm"
                        onClick={() => clonarQuestionario(q.id)}
                      >
                        Clonar
                      </button>
                      <button
                        type="button"
                        className="btn-ghost-sm danger"
                        onClick={() => excluirQuestionario(q.id)}
                      >
                        Excluir
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default Questionarios;
